import barba from '@barba/core';
import { gsap } from "gsap/all";
// import Cookies from 'js-cookie';

import Header from "./header";
import NavMobile from "./nav-mobile";
import Reveal from "./reveal";

export default class BarbaJs {

  constructor() {
    const html = document.querySelector('html');
    const body = document.querySelector('body');
    const langSwitcher = document.querySelector('.language-switcher');
    // const navigation = document.querySelector('.navigation--header');
    const navigationLinks = document.querySelectorAll('.navigation--header-link');
    var scrollPosY = [0];

    // const getAnalyticsContent = function () {
    //   let analytics_consent = false;
    //   const cookie_status = Cookies.get('cookie_status');
    //   if (cookie_status) {
    //     const categories = cookie_status.split(',');
    //     analytics_consent = categories.includes('analytics');
    //   }
    //   return analytics_consent;
    // }

    // // Define dataLayer and the gtag function.
    // window.dataLayer = window.dataLayer || [];
    // function gtag() { window.dataLayer.push(arguments); }

    // // Set default consent values
    // gtag('consent', 'default', {
    //   'ad_storage': getAnalyticsContent() ? 'granted' : 'denied',
    //   'ad_user_data': getAnalyticsContent() ? 'granted' : 'denied',
    //   'ad_personalization': getAnalyticsContent() ? 'granted' : 'denied',
    //   'analytics_storage': getAnalyticsContent() ? 'granted' : 'denied',
    // });

    // // listen for cookie updates
    // body.addEventListener('cookies:saved', (event) => {
    //   gtag('consent', 'update', {
    //     'ad_storage': event.detail.includes('analytics') ? 'granted' : 'denied',
    //     'ad_user_data': event.detail.includes('analytics') ? 'granted' : 'denied',
    //     'ad_personalization': event.detail.includes('analytics') ? 'granted' : 'denied',
    //     'analytics_storage': event.detail.includes('analytics') ? 'granted' : 'denied',
    //   });

    //   // history pushState to trigger GTM Tag
    //   const url = new URL(window.location);
    //   history.pushState({}, "", url);
    // });


    barba.init({
      timeout: 7500,

      // debug: true,
      // cacheIgnore: true,
      // prefetchIgnore: true,

      // requestError: (trigger, action, url, response) => {
      //   console.log({
      //     trigger: trigger,
      //     action: action,
      //     url: url,
      //     response: response,
      //   })
      // },

      prevent: ({ el }) => el.classList && (el.classList.contains('prevent-barba') || el.classList.contains('active')),

      transitions: [
        {
          name: 'default-transition',

          once(data) {
            // scroll to anchor
            if (window.location.hash) {
              const target = document.querySelector(window.location.hash);
              if (target) {
                setTimeout(() => {
                  target.scrollIntoView({
                    behavior: 'smooth',
                  });
                }, 250);
              }
            }

            setTimeout(() => {
              new Header();
              new NavMobile();
              new Reveal('.js--reveal');
            }, 1);

            return gsap.to(body, {
              opacity: 1,
              duration: 0.5,
              delay: 0.25,
            });
          },

          beforeLeave(data) {
            if (data.trigger !== "back") {
              scrollPosY.push(window.scrollY);
            }

            return gsap.to(data.current.container, {
              opacity: 0,
              duration: 0.5,
              // delay: data.trigger.classList != undefined && data.trigger.classList.contains('navigation--header-link') ? 0.2 : 0.1,
            });
          },

          afterLeave(data) {
            // update body classes
            body.classList.toggle('is-home', data.next.namespace === 'home');
            body.classList.toggle('not-home', data.next.namespace !== 'home');
            data.current.container.remove();
          },

          beforeEnter(data) {
            if (langSwitcher != null) {
              langSwitcher.href = data.next.container.dataset.translationUrl;
            }

            navigationLinks.forEach(navigationLink => {
              navigationLink.classList.toggle('text-theme-red', navigationLink.dataset.slug === data.next.namespace || navigationLink.dataset.slug === data.next.container.dataset.slug);
            });

            // // Set default consent values
            // gtag('consent', 'default', {
            //   'ad_storage': getAnalyticsContent() ? 'granted' : 'denied',
            //   'ad_user_data': getAnalyticsContent() ? 'granted' : 'denied',
            //   'ad_personalization': getAnalyticsContent() ? 'granted' : 'denied',
            //   'analytics_storage': getAnalyticsContent() ? 'granted' : 'denied',
            // });

            data.next.container.style.opacity = 0;
          },


          enter(data) {
            // reinit JS
            setTimeout(() => {
              // new Header();
              new NavMobile();
              new Reveal('.js--reveal');
            }, 1);

            if (data.trigger == 'back') {
              window.scrollTo(0, 0);
              let scrollPosYTarget = scrollPosY.pop();
              setTimeout(() => {
                window.scrollTo(0, scrollPosYTarget);
              }, 10);
            } else {
              window.scrollTo(0, 0);
            }
          },

          afterEnter(data) {
            window.scrollTo(0, 0);

            return gsap.to(data.next.container, {
              opacity: 1,
              duration: 0.5,
              delay: 0.25,
              // onStart: () => {
              // },
              onComplete: () => {
                // scroll to anchor
                if (window.location.hash) {
                  const target = document.querySelector(window.location.hash);
                  if (target) {
                    setTimeout(() => {
                      target.scrollIntoView({
                        behavior: 'smooth',
                      });
                    }, 250);
                  }
                }
              }
            });
          }

        },
      ],

    });
  }

}
